import { render, staticRenderFns } from "./GroupSettingsDropdown.vue?vue&type=template&id=3e4a7c43&scoped=true&"
import script from "./GroupSettingsDropdown.vue?vue&type=script&lang=js&"
export * from "./GroupSettingsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./GroupSettingsDropdown.vue?vue&type=style&index=0&id=3e4a7c43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4a7c43",
  null
  
)

export default component.exports